import {
  ComponentType,
  type IComponentModel,
  type IHeroComponentModel,
  type ITextComponentModel,
  type ITextComponentWithAssetsModel,
} from "@nf/common";

const isHeroBanner = (
  component: IComponentModel
): component is IHeroComponentModel =>
  component.ComponentTypeCode === ComponentType.HeroBanner;

export const mergeComponents = (
  components: IComponentModel[]
): IComponentModel[] =>
  components.reduce<IComponentModel[]>((acc, component, i) => {
    if (isHeroBanner(component)) return acc;

    const next = components[i + 1];

    if (next && isHeroBanner(next)) {
      const merged: ITextComponentWithAssetsModel = {
        ...(component as ITextComponentModel),
        MediaList: next.MediaList,
      };
      acc.push(merged);
    } else {
      acc.push(component);
    }

    return acc;
  }, []);
